import { render, staticRenderFns } from "./GGanttBar.vue?vue&type=template&id=549c125e&scoped=true"
import script from "./GGanttBar.vue?vue&type=script&lang=js"
export * from "./GGanttBar.vue?vue&type=script&lang=js"
import style0 from "./GGanttBar.vue?vue&type=style&index=0&id=549c125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c125e",
  null
  
)

export default component.exports